const arabicToPersian = (text) => {
  if (typeof text === "string") {
    if (text.trim() === "") {
      return "";
    }
    let unicodedPersianArray = [];
    let finalPerianTxt;

    if (text.length > 1) {
      for (let i = 0; i < text.length; i++) {
        let eachUnicodedAlphabet = text.charCodeAt(i);
        unicodedPersianArray.push(eachUnicodedAlphabet);
      }
    } else {
      unicodedPersianArray.push(text.charCodeAt(0));
    }

    for (let i = 0; i < unicodedPersianArray.length; i++) {
      if (unicodedPersianArray[i] === 1610) {
        unicodedPersianArray[i] = 1740;
      } else if (unicodedPersianArray[i] === 1603) {
        unicodedPersianArray[i] = 1705;
      }
    }

    for (let i = 0; i < unicodedPersianArray.length; i++) {
      unicodedPersianArray[i] = String.fromCharCode(unicodedPersianArray[i]);
    }

    finalPerianTxt = unicodedPersianArray.join("");
    return finalPerianTxt;
  }
};

export default arabicToPersian;
